import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    areaOfDeployment: checkText(settings),
});

export const AreaOfDeploymentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formAreaOfDeployment">
                <Form.Label>Gewünschter Einsatzbereich</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gewünschten Einsatzbereich eingeben"
                    type="text"
                    name="areaOfDeployment"
                    value={values.areaOfDeployment}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.areaOfDeployment && !errors.areaOfDeployment}
                    isInvalid={touched.areaOfDeployment && errors.areaOfDeployment}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.areaOfDeployment}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};
